//vas types
export const FLIGHT_NOTIFICATIONS = 'FLIGHT_NOTIFICATIONS'
export const FLIGHT_DELAY_PROTECTION = 'FLIGHT_DELAY_PROTECTION'
export const LUGGAGE_PROTECTION = 'LUGGAGE_PROTECTION'
export const AUTO_CHECKIN = 'AUTO_CHECKIN'
export const MEDICAL_INSURANCE = 'MEDICAL_INSURANCE'
export const EVENTS = 'EVENTS'
//vas providers
export const TRIPADD = 'TRIPADD'
export const TAWUNIYA = 'TAWUNIYA'
export const OFFLINE = 'OFFLINE'
export const insuranceTypes = [
    FLIGHT_NOTIFICATIONS,
    FLIGHT_DELAY_PROTECTION,
    LUGGAGE_PROTECTION,
    AUTO_CHECKIN,
    MEDICAL_INSURANCE
]

/**
 * `EVENTS` is a generic bucket, so a quantity-priced product is identified by the
 * `name` on its vasDetail — see `isTicketedVas`. Add a name here to onboard another one.
 */
export const GULF_CUP_SALES_DETAIL = 'GulfCupSalesDetail'
export const ticketedVasDetailNames = [GULF_CUP_SALES_DETAIL]
